import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductCard from "./ProductCard";

function ProductSection({ title, sectionIdx, products }) {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);

  const allProducts =
    products?.filter((item) => item.title && item.price) || [];

  const sectionProducts = showAll ? allProducts : allProducts.slice(0, 5);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-semibold text-slate-900">{title}</h2>
        {allProducts.length > 5 && !showAll && (
          <button
            type="button"
            onClick={() => setShowAll(true)}
            className="text-xs font-semibold text-indigo-600"
          >
            View more →
          </button>
        )}
      </div>

      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {sectionProducts.map((product, idx) => (
          <ProductCard
            key={idx}
            product={product}
            accent={["orange", "blue", "green", "purple"][(sectionIdx + idx) % 4]}
            onClick={() =>
              navigate(
                `/product/${encodeURIComponent(product.pid || product.sku)}`
              )
            }
          />
        ))}
      </div>
    </div>
  );
}

export default ProductSection;